import React from "react";
import Select from "react-select";
import { customSelectStyle } from "../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle";
import { clientLabelOf } from "../utils/clientLabel";

// vazio = consolidado, que é o estado default da tela
const ALL_CLIENTS_OPTION = { value: "", label: "Todos os clientes" };

// Seletor de cliente + período.
//
// O período busca no submit, não no onChange: dois <input type="date"> com
// auto-fetch dispararariam requisição a cada dígito, e data pela metade volta
// 400. O botão dispensa debounce e é correto no edge case.
//
// O cliente é o oposto — aplica na troca. É uma escolha única e já válida, e o
// nome do cliente exibido abaixo do form vem da resposta: sem aplicar na hora, o
// badge continuaria mostrando o cliente anterior ao que está no seletor.
export default function UsageFilters({
  clients,
  clientsError,
  formFilters,
  appliedFilters,
  setFormFilters,
  onApply,
}) {
  const updateFilter = (field, value) =>
    setFormFilters({ ...formFilters, [field]: value });

  // A troca de cliente carrega o período JÁ APLICADO, não o digitado: um `from`
  // ou `to` pela metade no form iria para a busca sem ninguém clicar em
  // "Aplicar" e voltaria 400, e é exatamente isso que CA-08 proíbe. O campo
  // continua com o que foi digitado — o submit é que o aplica.
  const selectClient = clientId => {
    setFormFilters({ ...formFilters, clientId });
    onApply({ ...appliedFilters, clientId });
  };

  const submitPeriod = event => {
    event.preventDefault();
    onApply(formFilters);
  };

  // O que vai para a query é sempre o `id` do calculator-api (`cli_…`), nunca o
  // `backendClientId`: só ele alcança cliente sem vínculo na Jusfy, e mandar os
  // dois é 400 (são mutuamente exclusivos). O ID da Jusfy aparece só no rótulo,
  // porque é por ele que o admin reconhece o cliente.
  const clientOptions = [
    ALL_CLIENTS_OPTION,
    ...clients.map(client => ({
      value: client.id,
      label: clientLabelOf(client),
    })),
  ];

  return (
    <>
      <form className="form-inline mb-2" onSubmit={submitPeriod}>
        <label className="mr-2" htmlFor="usage-client">
          Cliente
        </label>
        {/* react-select em vez do <select> nativo porque a rota de clientes não
            pagina: a lista vem inteira, e sem busca por digitação ela fica
            impraticável assim que passar de algumas dezenas */}
        <Select
          inputId="usage-client"
          className="mr-4"
          styles={{ container: base => ({ ...base, minWidth: 320 }) }}
          theme={customSelectStyle}
          options={clientOptions}
          value={
            clientOptions.find(option => option.value === formFilters.clientId) ??
            ALL_CLIENTS_OPTION
          }
          onChange={option => selectClient(option.value)}
          placeholder="Todos os clientes"
          noOptionsMessage={() => "Nenhum cliente encontrado"}
        />

        <label className="mr-2" htmlFor="usage-from">
          De
        </label>
        <input
          id="usage-from"
          type="date"
          className="form-control mr-4"
          value={formFilters.from}
          onChange={event => updateFilter("from", event.target.value)}
        />

        <label className="mr-2" htmlFor="usage-to">
          Até
        </label>
        <input
          id="usage-to"
          type="date"
          className="form-control mr-4"
          value={formFilters.to}
          onChange={event => updateFilter("to", event.target.value)}
        />

        <button type="submit" className="btn btn-primary">
          Aplicar
        </button>
      </form>

      {/* falha na lista não bloqueia a tela: o consolidado continua funcionando
          sem seletor. Mas precisa de sinal, senão "não carregou" e "não há
          clientes" ficam indistinguíveis. */}
      {clientsError && (
        <p className="text-muted mb-4">
          <small>
            {clientsError} O consolidado por cliente continua disponível.
          </small>
        </p>
      )}
    </>
  );
}
